import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';




@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {

  constructor( public dialogRef: MatDialogRef<ConfirmComponent>, @Inject(MAT_DIALOG_DATA) public data)
  {}
  message :string = "Voulez-vous Confirmez  ?";
  btnOk = {class:"colorRed",icon:"delete",text:"Confirmer"};
  btnAnnuler = {class:"colorRed",icon:"close",text:"Annuler"};
  ngOnInit() 
  {
    if(this.data != undefined )
    {
      if(this.data.message != undefined)
      {
        this.message  = this.data.message;
      }
      if(this.data.btnOk != undefined)
      {
        this.btnOk  = this.data.btnOk;
      }
      if(this.data.btnAnnuler != undefined)
      {
        this.btnAnnuler  = this.data.btnAnnuler;
      }
    }
  }
  close(action) 
  {
    this.dialogRef.close(action);
  }
}
